import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { PageColumn, EvenThirdsLayout } from "components/ui/PageColumns";

import { ClassInformationCard } from "components/cards/ClassInformationCard";
import { CourseSitesCard } from "components/cards/CourseSitesCard";
import { TeachingInstructorsCard } from "components/cards/TeachingInstructorsCard";
import { TextbooksCard } from "components/cards/TextbooksCard";

export default function ClassInfoTab({ currentCourse }) {
  const location = useLocation();
  const navigate = useNavigate();

  // When arriving on class info page that _DOESN'T_ end with a slash
  // redirect immediately to include the trailing slash.
  //
  // For example:
  // .../class/linguis-115-2022-D => .../class/linguis-115-2022-D/
  //
  // This is necessary because the tab switcher needs the trailing slash to
  // match the "Class Info" tab as being active using the NavLink component.
  useEffect(() => {
    const slash = location.pathname.slice(-1);
    if (slash !== "/") {
      navigate(`${location.pathname}/`);
    }
  }, [location]);

  return (
    <EvenThirdsLayout>
      <PageColumn>
        <ClassInformationCard />
      </PageColumn>
      <PageColumn>
        <TeachingInstructorsCard course={currentCourse} />
        <CourseSitesCard course={currentCourse} />
      </PageColumn>
      <PageColumn>
        <TextbooksCard />
      </PageColumn>
    </EvenThirdsLayout>
  );
}

ClassInfoTab.displayName = "ClassInfoTab";
ClassInfoTab.propTypes = {
  currentCourse: PropTypes.object,
  loadState: PropTypes.string,
};
